import { useState, useCallback } from 'react';
import styles from './page.module.css';
import { Decorations } from './components/Desktop/Decorations';
import {
  StatusBar,
  Terminal,
  Browser,
  Finder,
  Notepad,
  Paint,
  Dock,
  BootScreen,
  WindowManagerProvider,
  FileSystemProvider,
} from './components';
import { SelectionBox } from './components/Desktop/SelectionBox';

export function App() {
  const [systemBooted, setSystemBooted] = useState(false);
  const [notepadFile, setNotepadFile] = useState<{ path: string; content: string; key: number } | null>(null);
  const [paintFile, setPaintFile] = useState<{ path: string; content: string; key: number } | null>(null);

  const handleOpenFile = useCallback((path: string, content: string) => {
    if (path.endsWith('.png')) {
      setPaintFile({ path, content, key: Date.now() });
    } else {
      setNotepadFile({ path, content, key: Date.now() });
    }
  }, []);

  return (
    <main className={styles.main}>
      <WindowManagerProvider>
        {systemBooted && <StatusBar />}

        <div className={styles.desktopContainer}>
          {!systemBooted ? (
            <BootScreen onBootComplete={() => setSystemBooted(true)} />
          ) : (
            <div className={styles.desktop} data-desktop>
              <Decorations />
              <SelectionBox />
              <FileSystemProvider>
                <Finder onOpenFile={handleOpenFile} />
                <Terminal />
                <Browser />
                <Notepad
                  initialPath={notepadFile?.path}
                  initialContent={notepadFile?.content}
                  openKey={notepadFile?.key}
                />
                <Paint
                  initialPath={paintFile?.path}
                  initialContent={paintFile?.content}
                  openKey={paintFile?.key}
                />
                <Dock />
              </FileSystemProvider>
            </div>
          )}
        </div>
      </WindowManagerProvider>
    </main>
  );
}
